import { MfaEnrollmentComponent } from '@/features/auth';

export default function MfaEnrollPage() {
  return <MfaEnrollmentComponent />;
}
